import { ScrollArea } from '@mantine/core';
import {
    IconAdjustments,
    IconGauge,
    IconGridDots,
    IconUser
} from '@tabler/icons-react';
import React from 'react';
import classes from './Navbar.module.css';
import { LinksGroup } from './navbar/NavbarLinksGroup';
import UserButton from './navbar/userButton/UserButton';
const mockdata = [
    { label: 'Dashboard', icon: IconGauge, links: "/dashboard" },
    { label: 'Users', icon: IconUser, links: "/user" },
    { label: 'Themes', icon: IconGridDots, links: "/themes" },
    { label: 'Levels', icon: IconGridDots, links: "/levels" },
    { label: 'Agencies', icon: IconGridDots, links: "/agencies" },
    { label: 'Modules', icon: IconGridDots, links: "/module" },
    { label: 'Information', icon: IconGridDots, links: "/information" },
    { label: 'Match Styles', icon: IconGridDots, links: "/matchStyle" },
    { label: 'Match Limits', icon: IconGridDots, links: "/match-limits" },
    { label: 'Confirmed Matches', icon: IconGridDots, links: "/confirmed-matches" },
    { label: 'CustomPages', icon: IconGridDots, links: "/customPages" },
    { label: 'Subscriptions', icon: IconGridDots, links: "/subscriptions" },
    { label: 'Notifications', icon: IconGridDots, links: "/notifications" },

    //   {
    //     label: 'Market news',
    //     icon: IconNotes,
    //     initiallyOpened: true,
    //     links: [
    //       { label: 'Overview', link: '/' },
    //       { label: 'Forecasts', link: '/' },
    //       { label: 'Outlook', link: '/' },
    //       { label: 'Real time', link: '/' },
    //     ],
    //   },
    //   {
    //     label: 'Releases',
    //     icon: IconCalendarStats,
    //     links: [
    //       { label: 'Upcoming releases', link: '/' },
    //       { label: 'Previous releases', link: '/' },
    //       { label: 'Releases schedule', link: '/' },
    //     ],
    //   },
    //   { label: 'Analytics', icon: IconPresentationAnalytics },
    //   { label: 'Contracts', icon: IconFileAnalytics },
    // { label: 'Settings', icon: IconAdjustments, links: "/settings" },
    //   {
    //     label: 'Security',
    //     icon: IconLock,
    //     links: [
    //       { label: 'Enable 2FA', link: '/' },
    //       { label: 'Change password', link: '/' },
    //       { label: 'Recovery codes', link: '/' },
    //     ],
    //   },
];

function NavbarNested() {
    const links = mockdata.map((item) => <LinksGroup {...item} key={item.label} />);

    return (
        <nav className={classes.navbar}>


            <ScrollArea className={classes.links}>
                {links}
            </ScrollArea>

            <div className={classes.footer}>
                <UserButton />
            </div>
        </nav>
    );
}

export default NavbarNested
